import rg4js from 'raygun4js';

// [TNF] need to rebuild app if this changes
const raygunApiKey = process.env.RAYGUN_API_KEY;

if (raygunApiKey) {
  rg4js('enableCrashReporting', true);
  rg4js('raygunApiKey', raygunApiKey);
}
